import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import TrilhaAprendizadoLayout from './TrilhaAprendizadoLayout';
import TrilhaSetoresPage from './TrilhaSetoresPage';
import TrilhaPastasPage from './TrilhaPastasPage';
import TrilhaConteudosPage from './TrilhaConteudosPage';

/** Módulo Trilha de Aprendizado — isolado do shell de Contratos. */
export default function TrilhaAprendizadoModule() {
  return (
    <Routes>
      <Route path="/trilha-aprendizado" element={<TrilhaAprendizadoLayout />}>
        <Route index element={<TrilhaSetoresPage />} />
        <Route path="setores/:setorId" element={<TrilhaPastasPage />} />
        <Route path="pastas/:pastaId" element={<TrilhaConteudosPage />} />
        <Route path="*" element={<Navigate to="/trilha-aprendizado" replace />} />
      </Route>
    </Routes>
  );
}
